/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./nft.vue?vue&type=template&id=dc18a1ee&scoped=true"
import script from "./nft.vue?vue&type=script&lang=js"
export * from "./nft.vue?vue&type=script&lang=js"
import style0 from "./nft.vue?vue&type=style&index=0&id=dc18a1ee&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc18a1ee",
  null
  
)

export default component.exports